import { render, staticRenderFns } from "./ListAdvantage.vue?vue&type=template&id=2d598ff8&"
import script from "./ListAdvantage.vue?vue&type=script&lang=js&"
export * from "./ListAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports